window.Eureka = window.Eureka || {};
const translations = {
  annotator: {
    feedbackAreas: {
      criticalThinking: "Critical thinking",
      general: "General",
      generalComments: "General comments",
      ideaDevelopment: "Argument / Idea development",
      language: "Language",
      referrals: "%{client_short_name} resources",
      spellingAndGrammar: "Spelling and grammar",
      structure: "Structure",
      understandingAndComprehension: "Understanding and comprehension",
      useOfSources: "Use of sources"
    }
  },
  ballarat: {
    productName: "Quizzes"
  },
  bellmere: {
    abbreviation: "WF+",
    humanAbbreviation: "WF+",
    icon: "document-check",
    productName: "24/7 Writing Feedback+",
    productShortName: "Writing Feedback+",
    productSlug: "wf-plus",
    svgIcon: "icons/Studiosity_Icon-Bellmere.svg"
  },
  burley: {
    icon: "document-check",
    productName: "Study Assist",
    productShortName: "Study Assist",
    svgIcon: "icons/Studiosity_Icon-Burley.svg"
  },
  bunyip: {
    abbreviation: "CA",
    match: "Text match",
    productName: "Citation Assist",
    productShortName: "Citation Assist"
  },
  cardigan: {
    abbreviation: "WF",
    icon: "document-check",
    productName: "24/7 Writing Feedback",
    productShortName: "Writing Feedback",
    productSlug: "wf",
    svgIcon: "icons/Studiosity_Icon-Writing-feedback.svg"
  },
  camperdown: {
    productName: "Grammar Detection",
    productShortName: "Grammar"
  },
  griffin: {
    abbreviation: "CL",
    icon: "chat",
    productName: "Connect Live",
    productShortName: "Connect Live",
    productSlug: "cl"
  },
  mildura: {
    abbreviation: "AWE",
    productName: "Academic Writing Evaluation",
    productShortName: "Writing Evaluation",
    productSlug: "awe"
  },
  parkes: {
    productName: "Partner Portal"
  },
  sunbury: {
    abbreviation: "SC",
    productName: "Student Connect",
    productShortName: "Student Connect",
    productSlug: "sc"
  },
  yamba: {
    productShortName: "WF to CL"
  }
};

window.Eureka.translations = translations;
